import * as React from 'react';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing

// style
const style = css`
    > header {
        display: flex;
        align-items: center;
        padding: 10px 30px;
        font-size: 18px;
        text-transform: uppercase;
        color: #666;
        border-bottom: 1px solid #ccc;

        h2 {
            font-size: 24px;
            margin: 0;
        }
        > div {
            > span {
               display: inline-block;
               padding: 0 10px;
               font-size: 14px;

               > span {
                    padding-right: 5px;
                    font-size: 24px;
                    text-shadow: 1px 1px 1px #ccc, -1px -1px 1px #fff;
               }
            }

            .lvl-0 {
                color: ${vars.colors.red};
            }
            .lvl-1 {
                color: ${vars.colors.orange};
            }
            .lvl-2, .lvl-3 {
                color: ${vars.colors.green};
            }
        }
    }
`;

// component
export class Summary extends Proto<Props, State> {

    // render
    render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const { battery, cycle, count } = data.data;

        const steps = 4;
        let chargeLvl = 0, tempLvl = 2, liquidLvl = 0;
        for (let i=0; i<steps; i++) {
            const min = 100/steps * i;
            if (battery.soc > min) { // TODO
                chargeLvl = i;
            }
        }
        if (battery.temperature >= 50 || battery.temperature <= -5) {
            tempLvl = 1;
        }
        if (battery.temperature >= 60) {
            tempLvl = 0;
        }
        let powerLvl = 0; // TODO

        return (
            <article className={classNames('summary', style)}>
                <header>
                    <h2>{_('summary_title', 'BatteryOverview')} <strong>{battery.batterysn + (battery.batterybrand ? " " + battery.batterybrand : "") + (battery.devid ? " - " + battery.devid : "")}</strong></h2>
                    <div>
                        <span className={`lvl-${chargeLvl}`}><span className={`fa fa-battery-${chargeLvl}`} />{ (battery.soc != null) ? battery.soc : '--' }%</span>
                        <span className={`lvl-${tempLvl}`}><span className={`fa fa-thermometer-${tempLvl}`} />{ (battery.temperature != null) ? battery.temperature : '--' }°C</span>
                        <span className={`lvl-4`}><span className={`fa fa-hourglass`} />{battery.last_contact_diff} <small>({ (battery.last_contact != null) ? formatters.datetime(battery.last_contact) : 'Not synced yet' })</small></span>
                        {battery.lowliquid &&
                        <span className={`lvl-0`}><span className={`fa fa-tint`} />{_('summary_low', 'BatteryOverview')}</span>
                        }
                    </div>
                </header>
                <br />
                <div className="row">
                    <div className="col-sm-4">
                        <div className="detail-value-battery form-horizontal">
                            <div className="row form-group">
                                <label htmlFor="nominalvoltage" className="col-sm-5 control-label">{_('summary_filter_nominalvoltage', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="nominalvoltage" value={battery.nominalvoltage || ""} readOnly={true} />
                                </div>
                            </div>
                            <div className="row form-group">
                                <label htmlFor="nominalcapacity" className="col-sm-5 control-label">{_('summary_filter_nominalcapacity', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="nominalcapacity" value={battery.nominalcapacity || ""} readOnly={true} />
                                </div>
                            </div>
                            <div className="row form-group">
                                <label htmlFor="technology" className="col-sm-5 control-label">{_('summary_filter_technology', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="technology" value={battery.technology || ""} readOnly={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="detail-value-battery form-horizontal">
                            <div className="row form-group">
                                <label htmlFor="customer" className="col-sm-5 control-label">{_('summary_filter_customer', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="customer" value={battery.customer ? battery.customer.description : ""} readOnly={true} />
                                </div>
                            </div>
                            <div className="row form-group">
                                <label htmlFor="fleetname" className="col-sm-5 control-label">{_('summary_filter_fleet', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="fleetname" value={battery.fleetname || ""} readOnly={true} />
                                </div>
                            </div>
                            <div className="row form-group">
                                <label htmlFor="department" className="col-sm-5 control-label">{_('summary_filter_department', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="department" value={battery.dept ? battery.dept.description : ""} readOnly={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="detail-value-battery form-horizontal">
                            <div className="row form-group">
                                <label htmlFor="trucksn" className="col-sm-5 control-label">{_('summary_filter_trucksn', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="trucksn" value={battery.trucksn || ""} readOnly={true} />
                                </div>
                            </div>
                            <div className="row form-group">
                                <label htmlFor="truckmodel" className="col-sm-5 control-label">{_('summary_filter_truckmodel', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="truckmodel" value={battery.truckmodel || ""} readOnly={true} />
                                </div>
                            </div>
                            <div className="row form-group">
                                <label htmlFor="trucktype" className="col-sm-5 control-label">{_('summary_filter_trucktype', 'BatteryOverview')}</label>
                                <div className="col-sm-7 content-input">
                                    <input className="form-control" id="trucktype" value={battery.trucktype || ""} readOnly={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*
                <div className="detail-value-battery form-horizontal">
                    <div className="row">
                        <div className="col-lg-6 col-sm-12 row-detail">
                            <div className="form-group">
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="devid" className="col-sm-5 control-label">{_('summary_filter_devid', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="devid" value={battery.devid || ""} readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="batterymodel" className="col-sm-5 control-label">{_('summary_filter_batterymodel', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="batterymodel" value={battery.batterymodel || ""} readOnly={true} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="technology" className="col-sm-5 control-label">{_('summary_filter_technology', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="technology" value={battery.technology || ""} readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="nominalvoltage" className="col-sm-5 control-label">{_('summary_filter_nominalvoltage', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="nominalvoltage" value={battery.nominalvoltage || ""} readOnly={true} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="trucksn" className="col-sm-5 control-label">{_('summary_filter_trucksn', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="trucksn" value={battery.trucksn || ""} readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="truckmodel" className="col-sm-5 control-label">{_('summary_filter_truckmodel', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="truckmodel" value={battery.truckmodel || ""} readOnly={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12 row-detail">
                            <div className="form-group">
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="batterybrand" className="col-sm-5 control-label">{_('summary_filter_batterybrand', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="batterybrand" value={battery.batterybrand || ""} readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="newbattery" className="col-sm-5 control-label">{_('summary_filter_newbattery', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="newbattery" value={battery.newbattery || ""} readOnly={true} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="nominalcapacity" className="col-sm-5 control-label">{_('summary_filter_nominalcapacity', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="nominalcapacity" value={battery.nominalcapacity || ""} readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="telemetryid" className="col-sm-5 control-label">{_('summary_filter_telemetryid', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="telemetryid" value={battery.telemetryid || ""} readOnly={true} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="truckseries" className="col-sm-5 control-label">{_('summary_filter_truckseries', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="truckseries" value={battery.truckseries || ""} readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6">
                                    <label htmlFor="holdon" className="col-sm-5 control-label">{_('summary_filter_holdon', 'BatteryOverview')}</label>
                                    <div className="col-sm-7 content-input">
                                        <input className="form-control" id="holdon" value={battery.holdon || ""} readOnly={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>*/}
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BatteryOverview/Summary.tsx